import React, { useState, useContext } from "react";
import CustomerList from "./CustomerList";
import CreateCustomerForm from "./CreateCustomerForm";
import EditCustomerForm from "./EditCustomerForm";
import { AuthContext } from "../../contexts/AuthContext";

const Customers = () => {
  const [activeTab, setActiveTab] = useState("list");
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const { user } = useContext(AuthContext);

  const handleCustomerCreated = () => {
    setActiveTab("list");
    setRefreshTrigger((prev) => prev + 1);
  };

  const handleCustomerUpdated = () => {
    setEditingCustomer(null);
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <div className="container mt-4">
      <div className="row mb-4">
        <div className="col">
          <h2>Customer Management</h2>
          <p className="text-muted">
            Manage customer information and relationships.
            {user?.is_primary && " (Primary tenant access)"}
          </p>
        </div>
      </div>

      {/* PHI Notice */}
      <div
        className="alert alert-warning d-flex align-items-center mb-4"
        role="alert"
      >
        <i className="bi bi-shield-exclamation fs-4 me-3"></i>
        <div>
          <strong>Protected Health Information (PHI):</strong> This section
          contains sensitive customer data. All access and modifications are
          logged for HIPAA compliance. Unauthorized access is prohibited.
        </div>
      </div>

      {/* Tabs */}
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "list" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("list");
              setEditingCustomer(null);
            }}
          >
            <i className="bi bi-people"></i> All Customers
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "create" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("create");
              setEditingCustomer(null);
            }}
          >
            <i className="bi bi-person-plus"></i> Create Customer
          </button>
        </li>
      </ul>

      {/* Content */}
      <div className="tab-content mt-3">
        {/* List Mode */}
        {activeTab === "list" && !editingCustomer && (
          <>
            <h4>All Customers</h4>
            <CustomerList
              onEdit={(customer) => setEditingCustomer(customer)}
              refreshTrigger={refreshTrigger}
            />
          </>
        )}

        {activeTab === "list" && editingCustomer && (
          <>
            <h4>Edit Customer</h4>
            <EditCustomerForm
              customer={editingCustomer}
              onCancel={() => setEditingCustomer(null)}
              onUpdated={handleCustomerUpdated}
            />
          </>
        )}

        {/* Create Mode */}
        {activeTab === "create" && (
          <>
            <h4>Create Customer</h4>
            <CreateCustomerForm onCreated={handleCustomerCreated} />
          </>
        )}
      </div>

      {/* HIPAA Compliance Footer */}
      <div className="mt-5 p-3 bg-light rounded">
        <h6 className="text-muted">
          <i className="bi bi-shield-check"></i> HIPAA Compliance & Security
        </h6>
        <small className="text-muted">
          <ul className="mb-0">
            <li>All customer data is encrypted at rest and in transit</li>
            <li>Access to customer information is logged and audited</li>
            <li>
              Customer data is considered Protected Health Information (PHI)
            </li>
            <li>Each new customer automatically creates an inactive tenant</li>
            <li>
              Primary tenant users can view all customers across the system
            </li>
            <li>Soft deletion preserves data integrity for compliance</li>
          </ul>
        </small>
      </div>
    </div>
  );
};

export default Customers;
